module.exports = __webpack_public_path__ + "img/s-sl-banner.c4a348b2.png";